import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("ulti_admin_token");
  const userToken = localStorage.getItem("ulti_user_token");
  let token = null;
  if (config.url.startsWith("/admin")) {
    token = adminToken;
  } else if (config.url.startsWith("/auth")) {
    token = adminToken || userToken;
  } else {
    token = userToken;
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  return String(detail);
}
